export const pensjonsavtalerKategoriMapObj = {
  UNKNOWN: 'andre avtaler',
  PRIVAT_TJENESTEPENSJON: 'privat tjenestepensjon',
  INDIVIDUELL_ORDNING: 'individuelle ordninger',
} as const
